<template>
    <div class="behandlingar">
      <!-- 背景图片和标题 -->
      <div class="bg-section">
        <div class="title-container">
          <h1 class="main-title">TCM</h1>
          <h2 class="sub-title">BEHANDLINGAR</h2>
        </div>
      </div>
  
      <!-- 卡片区域 -->
      <div class="cards-container">
        <div class="cards">
          <div class="card" v-for="(card, index) in cards" :key="index">
            <img :src="card.image" alt="Card Image" class="card-img">
            <h3 class="card-title">{{ card.title }}</h3>
            <div class="card-content">
              <p>{{ card.content }}</p>
            </div>
            <router-link :to="card.link" class="card-btn">Läs mer</router-link>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BehandlingarPage",
    data() {
      return {
        cards: [
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 1",
            content: "Card 1 content",
            link: "/terapi"
          },
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 2",
            content: "Card 2 content",
            link: "/terapi"
          },
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 3",
            content: "Card 3 content",
            link: "/terapi"
          },
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 4",
            content: "Card 4 content",
            link: "/terapi"
          },
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 5",
            content: "Card 5 content",
            link: "/terapi"
          },
          {
            image: require("@/assets/terapi/terapi1.jpg"),
            title: "Card 6",
            content: "Card 6 content",
            link: "/terapi"
          }
        ]
      };
    },
  };
  </script>
  
  <style scoped>
  .behandlingar {
    min-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .bg-section {
    background-image: url('@/assets/bg.png');
    background-size: cover;
    background-position: center;
    padding: 40px;
    margin-bottom: 40px;
    color: black;
  }
  
  .title-container {
    border-left: 4px solid #2e7d32;
    padding-left: 20px;
    margin-bottom: 20px;
  }
  
  .main-title {
    font-size: 2.5rem;
    margin: 0;
  }
  
  .sub-title {
    font-size: 1.8rem;
    margin: 0;
    color: #2e7d32;
  }
  
  .cards-container {
    padding: 20px;
  }
  
  .cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  
  .card {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .card-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .card-title {
    color: #2e7d32;
    padding: 15px;
    margin: 0;
  }
  
  .card-content {
    background: #f5f5f5;
    padding: 15px;
    color: black;
  }
  
  .card-btn {
    display: block;
    text-align: center;
    padding: 10px;
    background: #2e7d32;
    color: white;
    text-decoration: none;
    transition: background 0.3s;
  }
  
  .card-btn:hover {
    background: #1e5d22;
  }
  
  @media (max-width: 768px) {
    .cards {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 480px) {
    .cards {
      grid-template-columns: 1fr;
    }
  }
  </style>